export default {
  en: {
    import: {
      facts: "Fact | Facts",
      rules: "Rule | Rules",
      fileUploadedName: "File Uploaded Name",
      noFileUploadedName: "- no file uploaded -",
      waitingUpload: "Waiting for the upload",
      downloadFile: "Download File",
      importFile: "Import File",
      importSuccessTitle: "Import Success",
      importSuccessText:
        "We were able to import <b>{qty}</b> {type} from the uploaded list. Check it | We were able to import <b>{qty}</b> {type} from the uploaded list. Check them",
      noVariablesDetectedDescription:
        "Make sure you use the template or a document that has the same structure as ours, that the data entered is valid and that the items in this document are not already registered in the system.",
      uploadFile: "Upload a File",
      fileUploadedDescription:
        "Upload a supported or use the model document to import your {type} list"
    }
  },
  pt: {
    import: {
      facts: "Fact | Facts",
      rules: "Regra | Regras",
      fileUploadedName: "Nome do arquivo carregado",
      noFileUploadedName: "- nenhum arquivo carregado -",
      waitingUpload: "Aguardando o upload",
      downloadFile: "Baixar Arquivo",
      importFile: "Importar Arquivo",
      importSuccessTitle: "Sucesso na importação",
      importSuccessText:
        "Conseguimos importar <b>{qty}</b> {type} da lista carregada. Verifique-{sufix} | Conseguimos importar <b>{qty}</b> {type} da lista carregada. Verifique-{sufix}s",
      noVariablesDetectedDescription:
        "Certifique-se de usar o modelo ou um documento que tenha a mesma estrutura que a nossa, de que os dados digitados são válidos e de que os itens deste documento já não estão cadastrados no sistema.",
      uploadFile: "Fazer upload de um arquivo",
      fileUploadedDescription:
        "Faça upload de um arquivo compatível ou use o documento modelo para importar sua lista de {type}"
    }
  },
  es: {
    import: {
      facts: "Fact | Facts",
      rules: "Regla | Reglas",
      fileUploadedName: "Nombre del archivo cargado",
      noFileUploadedName: "- No se ha cargado ningún archivo -",
      waitingUpload: "En espera de carga",
      downloadFile: "Descargando archivo",
      importFile: "Importando archivo",
      importSuccessTitle: "Importación correcta",
      importSuccessText:
        "Hemos conseguido importar <b>{qty}</b> {type} de la lista subida. Compruébalo | Hemos conseguido importar <b>{qty}</b> {type} de la lista subida. Compruébalos",
      noVariablesDetectedDescription:
        "Asegúrese de que utiliza la plantilla o un documento que tenga la misma estructura que el nuestro, que los datos introducidos son válidos y que los elementos de este documento no están ya registrados en el sistema.",
      uploadFile: "Cargar un archivo",
      fileUploadedDescription:
        "Sube un archivo compatible o utiliza el documento plantilla para importar tu lista de {type}"
    }
  }
}
